<template>
  <section class="flex flex-col  lg:px-6 px-3 relative" :class="'bg-theme-' + theme">
    <div class="w-full flex flex-col p-6 mx-auto max-w-screen-2xl py-20">
      <div class="pb-6 flex justify-between gap-3 flex-wrap">
        <h3 class="text-2xl md:text-4xl lg:text-5xl header ">
          {{ title }}
        </h3>
        <template v-if="buttons?.length === 1">
          <ButtonGeneral v-for="(button, index) in buttons" :key="index" v-bind="button" class="self-start"
            :theme="theme" />
        </template>
      </div>

      <Markdown v-if="body" :md="body">
        {{ body }}
      </Markdown>
      <div v-if="buttons?.length && buttons.length > 1" class="flex flex-wrap gap-3" />

      <component :is="components[component]" class="w-full pt-12 mx-auto" />
    </div>
  </section>
</template>

<script lang="ts" setup>
import type { Theme, Button } from '~/types'
import { ContactForm, Subscribe, Blogs, TeamAll, JournalRecent, CaseStudyAll, JournalUpcoming, JournalNext, CourseDirectory } from '#components'

interface Props {
  component: 'contact-form'
  title?: string
  body?: string
  buttons?: Button[]
  uid?: string
  theme?: Theme
}

const components = {
  'contact-form': ContactForm,
  'subscribe-form': Subscribe,
  'blogs': Blogs,
  'case-studies': CaseStudyAll,
  'team': TeamAll,
  'journal-recent': JournalRecent,
  'journals-upcoming': JournalUpcoming,
  'journal-next': JournalNext,
  'courses': CourseDirectory
}

withDefaults(defineProps<Props>(), { theme: '' })
</script>
